// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___1lf0E","container_1":"container_1___3Wafd","container_2":"container_2___2l-d3"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/cibc/styles.module.scss
// module id = 240
// module chunks = 0